export default __webpack_public_path__ + "static/media/logo.582902e3.png";